import { CoreUtil } from "./util";
import type { TrackingData } from "./types/tracking";

export type JSONQuery = { q: string; [key: string]: string };
export type AttributeResponse = string | null;
export type Keyword = { target: string; term: string; visual: string };
export type KeywordsJSON = { original: Keyword; keywords: Keyword[] };
export type Suggestions = KeywordsJSON & { suggestPos: CoreUtil["nextValue"] };

export function isKeywordsJSON(json: string | Record<string, unknown>): json is KeywordsJSON {
  return "keywords" in (json as Record<string, unknown>);
}

export enum MARK {
  SUGGEST_TIME_START = "suggest_time_start",
  SUGGEST_TIME = "suggest_time",
  EMPTY_STATE_TIME_START = "empty_state_time_start",
  EMPTY_STATE_TIME = "empty_state_time",
  INITIAL_SEARCH_BOX_TIME = "initial_search_box_time",
  SUGGEST_RENDER_TIME_START = "suggest_render_time_start",
  SUGGEST_RENDER_TIME = "suggest_render_time",
}

export enum HEADLINE {
  EMPTY_STATE = "BELIEBTE TRENDS",
  SUGGESTIONS = "Suchvorschläge",
}

export enum SELECTOR {
  LAYER = ".js_squirrel_searchSuggestionsContainer",
  SEARCH_CONTAINER = ".js_squirrel_searchContainer",
  SEARCH_WRAPPER = ".squirrel_searchbarWrapper",
  SEARCH_FORM = ".js_squirrel_searchForm",
  SEARCH_ICON = ".js_squirrel_searchIcon",
  HEADER_ELEMENT = ".js_find_header",
  SUGGEST_TERM = ".js_squirrel_searchSuggest",
  ABORT_BUTTON = ".js_squirrel_searchline__abort",
  CURTAIN = ".js_squirrel_searchCurtain",
  DELETE_BUTTON = ".js_squirrel_searchbar__delete",
  SUBMIT_BUTTON = ".js_squirrel_searchbar__submit",
  SEARCH_FIELD = ".js_squirrel_searchbar__input",
  SEARCH_TERM = ".js_squirrel_searchSuggest__term",
  MODIFIED_ARROW = ".js_squirrel_searchSuggest__arrow",
  SEARCHBAR = ".js_squirrel_searchbar",
  SELECTED_SEARCH_SUGGEST = ".squirrel_searchSuggest--selected",
  /*🤫*/
  SEARCH_SUGGEST = ".squirrel_searchSuggest",
  SUGGEST_ITEM = ".squirrel_searchSuggest__text",
}

export enum CLASSNAME {
  SEARCHBAR_WRAPPER_VISIBLE_SUGGESTIONS = "squirrel_searchbarWrapper--visibleSuggestions",
  SEARCHBAR_HEADER_VISIBILITY = "find_header--visibleSearchbar",
  SEARCHBAR_HEADER_ACTIVE = "find_header--activeSearch",
  SELECTED_SEARCH_SUGGEST = "squirrel_searchSuggest--selected",
  IGNORE_CLOSE_SUGGEST = "js_squirrel_ignore_close_suggest",
  HINT = "hint",
  SEARCHBAR_SHOW_BUTTONS = "squirrel_searchbar--showButtons",
  TRACK_MODIFIED = "san_track_modified",
  TRACK_SUGGEST = "san_track_suggest",
}

export enum DATA {
  POS = "data-suggestpos",
  TERM = "data-term",
  TARGET_TERM = "data-target-term",
  TARGET = "data-target",
  ERROR = "data-error",
  SUGGEST_URL = "data-suggestserveruri",
  SUGGEST_SEARCH_TERM = "data-suggest-search-term",
  SUGGEST_WORD_LIST = "data-suggestWordList",
  SUGGEST_WORD_LIST_COUNT = "data-suggestWordListCount",
  SUGGEST_POS = "data-suggestpos",
  ARTICLE_NUMBER_SEARCH = "data-article-number-search",
}

export enum KEY_CODE {
  ENTER = "13",
  ESC = "27",
  ARROW_UP = "38",
  ARROW_DOWN = "40",
}

/*🤫
🤫
🤫
🤫
🤫*/
export function getNextActiveElement(key: string, current: HTMLLIElement): Element | null {
  if (!current) {
    return null;
  }

  switch (key) {
    case KEY_CODE.ARROW_DOWN:
      return current.nextElementSibling as HTMLLIElement;
    case KEY_CODE.ARROW_UP:
      return current.previousElementSibling as HTMLLIElement;
    default:
      return null;
  }
}

/*🤫
🤫
🤫
🤫
🤫*/
export function encode(url: string, json: JSONQuery): string {
  return url + "?" + Object.keys(json).map(window.o_util.core.bind(json, param)).join("&");
}

/*🤫
🤫
🤫
🤫*/
export function param(this: JSONQuery, key: string): string {
  return encodeURIComponent(key) + "=" + encodeURIComponent(this[key]);
}

export function isCookieEnabled(): boolean {
  return window.o_util.cookie.get("cb") == "1";
}

export function extractTrackparameterFromUrl(tValue: string): TrackingData {
  const hashTrackingParameter: TrackingData = {};
  const decodedTValue: string = decodeURIComponent(tValue);
  if (decodedTValue) {
    const [, jsonString]: string[] = decodedTValue.split("=");
    if (jsonString) {
      const urlTrackingParameters: TrackingData = JSON.parse(jsonString);
      Object.keys(urlTrackingParameters).forEach((key: string) => {
        hashTrackingParameter[key] = urlTrackingParameters[key];
      });
    }
  }

  return hashTrackingParameter;
}

export function splitTrackingLabelsFromUrl(action: string): string[] {
  return action.split("#");
}
